export const SLICE_NAME = 'companyHours';
